import React from "react";
import { Badge } from "../../../components/ui/badge";
import { BranchEntry } from "../../../api/v2/types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";

interface BranchSelectorProps {
  branches: BranchEntry[];
  value: string;
  defaultBranch?: string;
  workingBranch?: string | null;
  onChange: (branch: string) => void;
  disabled?: boolean;
}

const BranchSelector = ({
  branches,
  value,
  defaultBranch,
  workingBranch,
  onChange,
  disabled = false,
}: BranchSelectorProps) => {
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className="w-[220px]">
        <SelectValue placeholder="Select branch" />
      </SelectTrigger>
      <SelectContent>
        {branches.map((branch) => (
          <SelectItem key={branch.name} value={branch.name}>
            <div className="flex items-center gap-2">
              <span>{branch.name}</span>
              {branch.name === defaultBranch ? <Badge variant="secondary">default</Badge> : null}
              {branch.name === (workingBranch || "") || branch.isWorkingBranch ? (
                <Badge variant="outline">working</Badge>
              ) : null}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default BranchSelector;
